export type SectionFieldKey =
  | 'title' | 'title2' | 'subtitle' | 'paragraph1' | 'paragraph2'
  | 'visionTitle' | 'visionText' | 'ctaPrimaryLabel' | 'ctaSecondaryLabel';

export type ItemFieldKey =
  | 'icon' | 'flag' | 'number' | 'title' | 'description' | 'label' | 'duration'
  | 'features' | 'popularVisas' | 'requirements';

export interface SectionConfig {
  label: string;
  layout: 'simple' | 'list';
  fields: SectionFieldKey[];
  itemFields?: ItemFieldKey[];
  hasHeroWidget?: boolean;
}

export const SECTION_CONFIG: Record<string, SectionConfig> = {
  'home.hero': { label: 'Início — Destaque principal', layout: 'simple', fields: ['title', 'title2', 'subtitle', 'ctaPrimaryLabel', 'ctaSecondaryLabel'], hasHeroWidget: true },
  'home.why': { label: 'Início — Por que escolher', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['icon', 'title', 'description'] },
  'home.services': { label: 'Início — Nossos Serviços', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['title', 'description', 'features'] },
  'home.stats': { label: 'Início — Números', layout: 'list', fields: [], itemFields: ['number', 'label'] },
  'home.ctaFinal': { label: 'Início — Chamada final', layout: 'simple', fields: ['title', 'subtitle', 'ctaPrimaryLabel', 'ctaSecondaryLabel'] },
  'about.hero': { label: 'Sobre — Destaque principal', layout: 'simple', fields: ['title', 'subtitle'] },
  'about.mission': { label: 'Sobre — Missão e Visão', layout: 'simple', fields: ['title', 'paragraph1', 'paragraph2', 'visionTitle', 'visionText'] },
  'about.values': { label: 'Sobre — Nossos Valores', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['icon', 'title', 'description'] },
  'about.numbers': { label: 'Sobre — Nossos Números', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['number', 'label', 'description'] },
  'immigration.hero': { label: 'Imigração — Destaque principal', layout: 'simple', fields: ['title', 'title2', 'subtitle'] },
  'immigration.types': { label: 'Imigração — Tipos de Imigração', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['icon', 'title', 'description'] },
  'immigration.countries': { label: 'Imigração — Países de Destino', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['flag', 'title', 'description', 'popularVisas', 'requirements'] },
  'immigration.process': { label: 'Imigração — Nosso Processo', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['icon', 'title', 'description', 'duration'] },
  'immigration.services': { label: 'Imigração — Nossos Serviços', layout: 'list', fields: ['title', 'subtitle'], itemFields: ['title', 'description', 'features'] },
  'contact.hero': { label: 'Contato — Destaque principal', layout: 'simple', fields: ['title', 'title2', 'subtitle'] },
  'contact.form': { label: 'Contato — Formulário', layout: 'simple', fields: ['title', 'subtitle'] },
  'contact.map': { label: 'Contato — Localização', layout: 'simple', fields: ['title', 'subtitle'] }
};

export const SECTION_FIELD_LABELS: Record<SectionFieldKey, string> = {
  title: 'Título',
  title2: 'Título (parte destacada)',
  subtitle: 'Subtítulo',
  paragraph1: 'Parágrafo 1',
  paragraph2: 'Parágrafo 2',
  visionTitle: 'Título da Visão',
  visionText: 'Texto da Visão',
  ctaPrimaryLabel: 'Botão principal',
  ctaSecondaryLabel: 'Botão secundário'
};

export const SECTION_FIELD_MULTILINE: Partial<Record<SectionFieldKey, boolean>> = {
  subtitle: true,
  paragraph1: true,
  paragraph2: true,
  visionText: true
};

export const ITEM_FIELD_LABELS: Record<ItemFieldKey, string> = {
  icon: 'Ícone',
  flag: 'Bandeira (emoji)',
  number: 'Número',
  title: 'Título',
  description: 'Descrição',
  label: 'Rótulo',
  duration: 'Duração',
  features: 'Lista (tópicos)',
  popularVisas: 'Vistos populares',
  requirements: 'Requisitos'
};

export const ITEM_FIELD_MULTILINE: Partial<Record<ItemFieldKey, boolean>> = {
  description: true
};
